/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { UtilityService } from '../../services/utility.service';
const utility = new UtilityService(null, null, null);
/**
 * headers
 * content-type
 */
class Headers {
  requestid: string;
  'Content-Type': string;
}



/**
 * getHeaders
 * @param getHeaders;
 * @param path;
 * @returns header
 * requestid
 */
export function getHeaders(path?) {
  const header = new Headers();

  header.requestid = `${new Date().getTime()}${utility.getCookie('USERNAME')}`;
  if (!path) {
    header['Content-Type'] = 'application/json';
  }

  return header;
}
